export const ACTION = {
    SEARCH_CONTENT: 'SEARCH_CONTENT',
    SEARCH_FILTER: 'SEARCH_FILTER',
    SEARCH_RESET: 'SEARCH_RESET',
    SEARCH_FILTER_LANGUAGE: 'SEARCH_FILTER_LANGUAGE',
    SEARCH_FILTER_GENRE: 'SEARCH_FILTER_GENRE',
    SEARCH_DATA_RESET: 'SEARCH_DATA_RESET',
    VOOT_CONTENT_PARAMS:'VOOT_CONTENT_PARAMS',
};